var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"removal",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _setup.openModal.apply(null, arguments)}}},[_c('FontAwesomeIcon',{attrs:{"icon":_setup.faTimes}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('WEBAPP_LOGINS_REMOVE'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }